import { RoleEnum } from "./RoleEnum"

export interface UserEditItem {
  userId: number;
  phone: string;
  email: string;
  roleId: RoleEnum;
  isActive: boolean
}


export const userEditItemInitial = (): UserEditItem => {
  return {
    userId: 0,
    phone: "",
    email: "",
    roleId: RoleEnum.None,
    isActive: true
  }
}